module.exports = __webpack_public_path__ + "static/media/ico_cb_notice.46389a20.svg";